import { TextArea, XStack, isWeb, XPPlatform } from '@my/ui'
import { color } from '@my/util'
import { IconButton } from '../common'
import assets from '../../assets/images'
import { Controller } from 'react-hook-form'
import { useMemo } from 'react'

// ChatInput Props
interface ChatInputProps {
  control: any
  onSubmit: (text: string) => void
  getValues: () => { chatInput: string }
  height?: number
}

const useIsDesktopWeb = () => {
  return useMemo(() => {
    // 1. If it's not a browser at all (Native iOS/Android), it's not desktop web
    if (!isWeb || XPPlatform.OS !== 'web') return false;

    // 2. Feature detection: Desktop browsers generally don't have "coarse" pointers
    // This correctly identifies iPad/Tablets/Phones as "not desktop" even in browser mode
    const isTouchDevice = 
      typeof window !== 'undefined' && 
      (window.matchMedia("(pointer: coarse)").matches || 'ontouchstart' in window);

    return !isTouchDevice;
  }, []);
};

// ChatInput Component
export const ChatInput: React.FC<ChatInputProps> = ({ control, onSubmit, getValues, height }) => {
  const isDesktopWeb = useIsDesktopWeb();

  const handleKeyPress = (e) => {
    // Only apply "Shift + Enter" logic to Desktop Web
    if (isDesktopWeb) {
      if (e.key === 'Enter' && !e.shiftKey) {
        // Desktop: Enter (no shift) = Submit
        e.preventDefault();
        onSubmit(getValues().chatInput);
      }
      // Desktop: Shift + Enter = Default New Line
    } else {
      // Mobile/Native: Enter always = New Line
      // Submission should be handled by a dedicated UI button
    }
  };
  const onChangeText = (textInput: string, onChange: any) => {
    
    let newValue = textInput.endsWith('\n') && !textInput.endsWith('\n\n') ? `${textInput.slice(0,-1)}  \n` : textInput;
    if (newValue.trim() === '') {
      newValue = '';
    }
    onChange(newValue);
  };

  return <XStack
    minHeight={height ?? 54}
    //borderWidth={1}
    //borderRadius={15}
    alignItems="center"
    justifyContent="space-between"
    borderColor={color.tzaGreen}
    //paddingHorizontal={15}
    //paddingVertical={10}
    width={'100%'}
    bg={color.white}
    gap={10}
  >
    <Controller
      control={control}
      name="chatInput"
      render={({ field: { onChange, value } }) => {
        const numOfLines = value.split('\n').length;
        const backupHeight: any = numOfLines === 1 ? '1.2em' : Math.min(120, Math.max(54, numOfLines*20));
        return <TextArea
          //unstyled
          flex={1}
          fontSize={17}
          value={value}
          minHeight={Math.max(height ?? 0, 54)}
          height={height ?? backupHeight}
          style={{lineHeight: 'normal'}}
          color={'#495057'}
          placeholder="Ask Savvy"
          onChangeText={(newText) => onChangeText(newText, onChange)}
          placeholderTextColor={'#495057'}
          onKeyDown={handleKeyPress}
        />
      }}
    />
    <XStack gap={7}>
      <IconButton
        onPress={() => onSubmit(getValues().chatInput)}
        iconSource={assets.sendIcon}
        iconTintColor={color.white}
      />
      {/* <IconButton iconTintColor={color.white} iconSource={assets.microphone} /> */}
    </XStack>
  </XStack>
}
